import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.user,
    props.modals_action.data.welcome_package,
    props.user.welcome_bonus,
    (user, data, welcome_bonus) => {
        return {
            user,
            data,
            welcome_bonus
        }
    }
)